import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17fd39ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-row" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "p-input-icon-left search-product-input p-relative" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search pi-search-position" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "negative-result"
}
const _hoisted_6 = {
  key: 1,
  class: "negative-result"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f icon-small-arrow fs-12" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputText, {
          style: {"text-indent":"15px"},
          type: "text",
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          placeholder: _ctx.$t('cashier.label.search'),
          onInput: _ctx.changeOutSideClick,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["modelValue", "placeholder", "onInput"])
      ])
    ]),
    (_ctx.outSideClick && _ctx.searchText.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "search-result",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_ctx.searchText.length == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("cashier.alert.more-then1char")), 1))
            : (!_ctx.rows || !_ctx.rows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("cashier.alert.no-result")), 1))
              : (_ctx.rows.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "product-search-result-row",
                        key: index,
                        onClick: ($event: any) => (_ctx.onSelect(row.id))
                      }, [
                        _createElementVNode("div", null, _toDisplayString(row.name), 1),
                        _hoisted_9
                      ], 8, _hoisted_8))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}